import { Controller } from "@hotwired/stimulus";

/**
 * Оценка звёздами.
 *
 * Заменяет lib/stars.js, который вешался на `.star` по всему документу и на
 * единственный `input[name=rating]`: на полке это связывало звёзды всех
 * карточек с одним полем. Контроллер работает только внутри своего элемента.
 *
 * Значение живёт в `data-rating-value-value`, поэтому его можно выставить
 * снаружи — например, открыв сохранённый черновик рецензии.
 */
export default class extends Controller {
  static targets = ["star", "input", "hint"];
  static values = { value: Number };

  connect() {
    if (!this.hasValueValue && this.hasInputTarget) {
      this.valueValue = Number(this.inputTarget.value) || 0;
    }
    this.paint();
  }

  valueValueChanged() {
    this.paint();
  }

  /** Подсветка звёзд под курсором. */
  preview(event) {
    const upto = this.starTargets.indexOf(event.currentTarget) + 1;
    this.starTargets.forEach((star, index) => {
      star.classList.toggle("hovered", index < upto);
    });
  }

  /** Возврат к выбранной оценке, когда курсор ушёл. */
  reset() {
    for (const star of this.starTargets) star.classList.remove("hovered");
  }

  /** Запоминает оценку. */
  select(event) {
    this.valueValue = this.starTargets.indexOf(event.currentTarget) + 1;
  }

  /** Перерисовывает ряд и синхронизирует скрытое поле формы. */
  paint() {
    this.starTargets.forEach((star, index) => {
      star.classList.remove("hovered");
      star.classList.toggle("selected", index < this.valueValue);
    });

    if (this.hasInputTarget) this.inputTarget.value = String(this.valueValue);
    if (this.hasHintTarget) {
      this.hintTarget.textContent = this.valueValue ? `${this.valueValue} из 5` : "Не оценено";
    }
  }
}
